module.exports = __webpack_public_path__ + "static/media/phoneupload.79518750.png";